export function generateRandomId(max: number) {
    return Math.floor(Math.random() * max) + 1
}

export function generateRandomIdV2(): number {
    return generateRandomId(generateRandomId(generateRandomId(1000000000))) + generateRandomId(1000000) + generateRandomId(1000000)
}


